/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, config} from 'Utils';
import {materialScreening2} from '../../service/inventoryQuery';
import {dmsPurchaseList, getCustomerReceiptList, getCustomerReceiptListExportExcel} from '../../service/reportForm';
import {Store, Actions} from './store';
import {fetchChannelList} from "../../service/home";

class CustomerReturnQuery extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.channelId = window.sessionStorage.getItem('cur_channelId');
        this.state = {
            opts: ['客户回款查询'],
            key: 0,
            channelCode: this.channelId,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            dateMapTotal: '',
            searchObj: {
                s: 10,
                p: 1,
                salesChannelCode: '',
                receiptDateBegin: '',
                receiptDateEnd: '',
                salesUnitId: ''
            },
            objType_type: [],
            objType_type2: [],
            categoryData: [],
            button_limits_end: {},
            loading: false
        };
        this.pageChange = this.pageChange.bind(this);
        this.changeHandle = this.changeHandle.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }

    goView(url) {
        hashHistory.push(url);
    }

    goAdd = () => {
        let param = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/customerReceipt/exportExcel`;
        let urlStr = '';
        Object.keys(param).forEach(item => {
            urlStr += `&${item}=${param[item]}`;
        });
        url += `?${urlStr.substring(1)}`;
        window.open(url);
    }

    changeHandle({item, key, keyPath}) {
        this.setState({key});
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                salesChannelCode: '',
                receiptDateBegin: '',
                receiptDateEnd: '',
                salesUnitId: '',
                s: 10,
                p: 1,
            }, loading: false
        }, function () {
            //self.initData();
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        if (!this.state.searchObj.receiptDateBegin || this.state.searchObj.receiptDateBegin == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        if (!this.state.searchObj.receiptDateEnd || this.state.searchObj.receiptDateEnd == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'date') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    receiptDateBegin: value.from,
                    receiptDateEnd: value.end
                }
            })
        } else {
            if (value == 'ALL') {
                this.setState({searchObj: {...this.state.searchObj, [name]: ''}})
            } else {
                this.setState({searchObj: {...this.state.searchObj, [name]: value}})
            }
        }
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    updateProductStatusFn(key) {
        /* 产品上下架 */
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        let params = {
            'ids': this.state.selectedRowKeys
        };
        let self = this;
        // if (key == 'up') {
        // 	setProductUp(params).then(function (result) {
        // 		if (result && result.code == 200) {
        // 			openNotice('success', '上架操作成功', '');
        // 			self.initData();
        // 		} else {
        // 			openNotice('error', '上架操作失败', (result && result.message) ? result.message : '');
        // 		}
        // 	});
        // } else {
        // 	setProductDown(params).then(function (result) {
        // 		if (result && result.code == 200) {
        // 			openNotice('success', '下架操作成功', '');
        // 			self.initData();
        // 		} else {
        // 			openNotice('error', '下架操作失败', (result && result.message) ? result.message : '');
        // 		}
        // 	});
        // }
    }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        // searchObj.categoryId = searchObj.category.length > 0 ? searchObj.category[searchObj.category.length - 1] : '';
        getCustomerReceiptList(searchObj).then((result) => {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total || 1,
                    'dateMapTotal': result.dataMap ? result.dataMap.total : 0,
                    loading: false
                });
            } else {
                openNotice('error', '数据获取失败', '');
                this.setState({loading: false});
            }
        })
        // getStockList(searchObj).then(function (result) {
        // 	if (result && result.code == 200) {
        // 		self.setState({
        // 			'rows': result.data || [],
        // 			'total': result.total
        // 		});
        // 	} else {
        // 		openNotice('error', '数据获取失败', '');
        // 	}
        // });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        let self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }
        /*渠道类型*/
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_type: arr},
                )
            }
        });
        //this.initData();
        // getProductCategory().then(function (categoryResult) {
        // 	/* 产品分类 */
        // 	if (!categoryResult || categoryResult.code != 200) {
        // 		openNotice('error', '产品分类数据获取失败，请重试', '');
        // 		return;
        // 	}
        // 	self.setState({
        // 		categoryData: categoryResult.data || []
        // 	});
        // });
        // getSubStoreList().then(res => { //物料类别
        //     if(res.status){
        //         let arr = [
        //             {
        //                 text: '全部',
        //                 value: ''
        //             }
        //         ];
        //         res.data.forEach(x => {
        //             arr.push({
        //                 text: x.subStoreName,
        //                 value: x.id
        //             })
        //         });
        // 	self.setState({objType_type: arr})
        //     }

        // });
        // materialScreening2().then(res => { //物料类别
        // 	if(res.status){
        // 	    let arr = [
        // 	        {
        // 	            text: '全部',
        // 	            value: ''
        // 	        }
        // 	    ];
        // 	    res.data.forEach(x => {
        // 	        arr.push({
        // 	            text: x.subStoreName,
        // 	            value: x.id
        // 	        })
        // 	    });
        // 	    let timer = window.setInterval(function(){
        // 	        if(self.mounted){
        // 	            window.clearInterval(timer);
        // 	            self.setState({objType_type2: arr})
        // 	        }
        // 	    }, 0);
        // 	}
        // });
    }

    componentDidMount() {
        // this.initData();
        //设置离开当前路由时的钩子函数
        dmsPurchaseList({channelCode: this.state.channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                this.setState({gouxiaoUnitList: arr})
            }
        });
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    render() {
        const {
            opts,
            key,
            rows,
            total,
            searchObj,
            dateMapTotal,
            selectedRowKeys,
            objType_type,
            button_limits_end,
            loading,
            gouxiaoUnitList,
            channel_type
        } = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'date',//startCreatedDate, endCreatedDate
                    label: '收款日期',
                    options: [
                        {text: '从'},
                        {text: '至'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.receiptDateBegin || '',
                        end: searchObj.createTimeEnd || ''
                    }
                },
                {
                    name: 'salesChannelCode',
                    label: '渠道',
                    text: '选择渠道',
                    options: channel_type,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: false,
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '请输入关键字',
                    type: 'select',
                    options: gouxiaoUnitList,
                    showSearch: true,
                    defaultValue: searchObj.salesUnitId
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'rn',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '收款组织',
                    dataIndex: 'ouName',
                }, {
                    title: '购货单位',
                    dataIndex: 'salesUnitName',
                }, {
                    title: '收款日期',
                    dataIndex: 'receiptDate',
                }, {
                    title: '收款单据',
                    dataIndex: 'receiptNumber',
                }, {
                    title: '收款金额',
                    dataIndex: 'amount'
                }, {
                    title: '付款方式',
                    dataIndex: 'payType',
                }, {
                    title: '录入日期',
                    dataIndex: 'creationDate',
                }, {
                    title: '备注',
                    dataIndex: 'comments',
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key} onChange={this.changeHandle}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew  {...filterBoxProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.goAdd.bind(this)} style={{position: 'absolute', bottom: 8, right: 0}}
                            icon="export">导出</Button>
                </div>
                <TableView {...tableViewProps} />
                <p>销售金额合计：{dateMapTotal}</p>
            </div>
        </div>
    }
}
;
export default withRouter(CustomerReturnQuery);


// WEBPACK FOOTER //
// ./src/routes/reportForm/customerReturnQuery.js